import React from 'react';

import { QRCode } from 'react-qrcode-logo';

export interface IQRCodeOptions {
  enableCORS: boolean;
  size: number;
  ecLevel?: 'L' | 'M' | 'Q' | 'H';
  fgColor?: string;
  logoHeight?: number;
  logoImage?: string;
  logoOpacity?: number;
  logoPadding?: number;
  logoWidth?: number;
}

interface IQRCodeProps {
  options: IQRCodeOptions;
  url: string;
}

export const WidgetQrCode: React.FC<IQRCodeProps> = ({ url, options }) => <QRCode value={url} {...options} />;
